import React, { Component } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import Url from "app/shared/constants/Url";
import LoadingImage from "app/shared/components/Loader/LoadingImage";
import { connect } from "react-redux";
import { checkPermittedRoute } from "app/shared/utility/UtilFunction";
import CommonDropdown from "../ReportModal/CommonDropdown";
import axios from "axios";
import WorkPermitApiService from "app/views/Work_Permit/workpermit/services/WorkPermitApiService";
import AlertMessage from "app/shared/components/Popups/AlertMessage";
import { SuccessToast } from "app/shared/components/Popups/ToastMessage";
import { withRouter } from "react-router-dom";
import { requiredMessage } from "app/shared/constants/Messages";
import DatePicker from "react-datepicker";
import { Calendar } from "react-feather";
import moment from "moment";
import {
  convertDateFromTimezone,
  convertDateToUTC,
} from "app/shared/utility/tzUtilFunction";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
const mapStateToProps = (state) => {
  const data = [...state.permitModule.permittedModuleList];
  return {
    permittedModuleList: data,
  };
};

class CloseModal extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;

    let time = new Date();
    let addedTime = new Date();
    addedTime = addedTime.setHours(time.getHours() + 1);
    this.state = {
      closingReasonList: [
        { id: 1, closingReason: "Work Completed" },
        { id: 2, closingReason: "Work Stopped" },
        { id: 3, closingReason: "Work Cancelled" },
      ],
      declineReasonList: [
        { id: 1, declineReason: "Risk Assessment Not done " },
        { id: 2, declineReason: "No permit required for work" },
        { id: 3, declineReason: "Insufficient Control measure" },
        { id: 4, declineReason: "Work Cancelled" },
        { id: 5, declineReason: "Work Stopped" },
      ],
      extendReasonList: [
        { id: 1, closingReason: "Work not completed" },
        { id: 2, closingReason: "Limited resource" },
      ],
      closingActionId: null,
      closingActionError: false,
      closingRemarkText: null,
      closingRemarkTextError: false,
      reasonList: [],
      dropDownTitle: null,
      selectedEndDate: addedTime,
      maxDatepickerDate: new Date(),
      url: "",
      extendedTimeDuration: 1,
    };
  }

  componentDidMount = async () => {
    var title = "Closing";
    var list = this.state.closingReasonList;
    var tempUrl = Url.formType1.workPermitClose;
    switch (this.props.type) {
      case "close":
        title = this.props.t("closing");
        list = this.state.closingReasonList;
        tempUrl = Url.formType1.workPermitClose;
        break;
      case "stop":
        title = this.props.t("stop");
        list = this.state.closingReasonList;
        tempUrl = Url.formType1.workPermitClose;
        break;
      case "revoke":
        title = this.props.t("revoke");
        list = this.state.closingReasonList;
        tempUrl = Url.formType1.workPermitClose;
        break;
      case "decline":
        title = this.props.t("decline");
        list = this.state.declineReasonList;
        tempUrl = Url.formType1.workPermitDecline;
        break;
      case "extend":
        title = this.props.t("extend");
        list = this.state.extendReasonList;
        tempUrl = Url.formType1.workPermitExtend;
        break;
      default:
        title = this.props.t("closing");
        list = this.state.closingReasonList;
        tempUrl = Url.formType1.workPermitClose;
    }
    await this.setState((prevState) => {
      let { dropDownTitle, reasonList, url } = prevState;
      dropDownTitle = title;
      reasonList = list;
      url = tempUrl;
      return { dropDownTitle, reasonList, url };
    });

    if (this.props.extendData?.endDate) {
      const cal = this._calculateEndDate();
      this.setState(
        (prev) => ({
          selectedEndDate:
            prev.selectedEndDate && prev.selectedEndDate > cal
              ? prev.selectedEndDate
              : cal,
        }),
        () => this._getRemainingTime(), // ✅ pass a function here
      );
    }

    // this._getRemainingTime();
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.extendData?.endDate &&
      this.props.extendData?.endDate !== prevProps.extendData.endDate
    ) {
      const cal = this._calculateEndDate();

      this.setState(
        (prev) => ({
          selectedEndDate:
            prev.selectedEndDate && prev.selectedEndDate > cal
              ? prev.selectedEndDate
              : cal,
        }),
        () => this._getRemainingTime(), // ✅ pass a function here
      );
    }
  }

  _setDataLoading = async (status) => {
    await this.setState((prevState) => {
      let { dataLoading } = prevState;
      dataLoading = status;
      return { dataLoading };
    });
  };

  _parseDurationToHours(durationStr) {
    if (!durationStr || typeof durationStr !== "string") {
      return 8; // fallback to 8 hours
    }
    const match = durationStr.match(/(\d+)\s*(hour|hr|minute|min|day|d)/i);
    if (!match) {
      const digitsOnly = durationStr.match(/(\d+)/);
      if (digitsOnly) {
        return parseInt(digitsOnly[1], 10);
      }
      return 8; // fallback to 8 hours
    }
    const value = parseInt(match[1], 10);
    const unit = match[2].toLowerCase();
    if (unit.startsWith("min")) {
      return value / 60;
    } else if (unit.startsWith("day") || unit === "d") {
      return value * 24;
    } else {
      return value;
    }
  }

  _getRemainingTime = () => {
    if (this.props.type !== "extend" || !this.props.extendData) {
      return;
    }

    let diffInMilliSeconds =
      Math.abs(
        this.state.selectedEndDate -
          moment(
            convertDateFromTimezone(this.props.extendData.endDate),
            "DD-MM-YYYY HH:mm",
          ).valueOf(),
      ) / 1000;
    console.log(diffInMilliSeconds);

    //Calculate hours
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;
    console.log("calculated hours", hours);

    if (typeof hours !== "number" || isNaN(hours)) {
      this.setState({
        extendedTimeDuration: 0,
        totalDuration: 0,
      });
      return;
    }

    const additionalHours = this._parseDurationToHours(
      this.props.extendData.timeDuration || "8 hour(s)",
    );

    this.setState((prevState) => {
      prevState.extendedTimeDuration = hours;
      prevState.totalDuration = hours + additionalHours;
      return prevState;
    });
  };

  _handleChange = async (item, type) => {
    await this.setState((prevState) => {
      switch (type) {
        case "closing_remark":
          let { closingRemarkText, closingRemarkError } = prevState;
          closingRemarkText = item;
          closingRemarkError = !item ? true : false;
          return { closingRemarkText, closingRemarkError };
        case "end_date":
          let { selectedEndDate, selectedEndDateError } = prevState;
          selectedEndDate = item;
          selectedEndDateError = !item ? true : false;
          return { selectedEndDate, selectedEndDateError };
        default:
          return prevState;
      }
    });
    this._getRemainingTime();
  };

  _closingActionChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { closingActionId, closingActionError } = prevState;
      closingActionId = id;
      closingActionError = id ? false : true;
      return { closingActionId, closingActionError };
    });
  };

  handleWorkPermitClose = async () => {
    if (this.props.type == "close" && this.props.scheduleId) {
      if (!this.state.closingRemarkText) {
        this.setState({ closingRemarkError: true });
        return;
      }
      if (!this.state.closingActionId) {
        this.setState({ closingActionError: true });
        return;
      }

      await this._setDataLoading(true);
      try {
        const response = await WorkPermitApiService.closeWorkPermit(
          this.props.scheduleId,
          this.state.closingRemarkText,
          this.state.closingActionId,
          convertDateToUTC(new Date()),
        );
        await this._setDataLoading(false);
        // if (
        //   response &&
        //   (response.status === 200 ||
        //     response.status === "200" ||
        //     response.status === "success" ||
        //     response.success === true ||
        //     response.code === 200 ||
        //     response.code === "200")
        // ) {
        AlertMessage({
          message: "Work Permit Closed Successfully.",
          type: "success",
        });
        this.props.handleClose();
        this.props.refresh();
        // } else {
        //   AlertMessage({
        //     message:
        //       response.message ||
        //       "Failed to close work permit. Please try again.",
        //     type: "error",
        //   });
        // }
      } catch (error) {
        await this._setDataLoading(false);
        AlertMessage({
          message: "Something went wrong. Please try again.",
          type: "error",
        });
      }
      return;
    }

    if (this.props.type == "extend" && this.props.scheduleId) {
      if (!this.state.closingRemarkText) {
        this.setState({ closingRemarkError: true });
        return;
      }
      if (!this.state.closingActionId) {
        this.setState({ closingActionError: true });
        return;
      }
      if (!this.state.selectedEndDate) {
        this.setState({ selectedEndDateError: true });
        return;
      }

      await this._setDataLoading(true);
      try {
        var endDate = moment(this.state.selectedEndDate).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        const response = await WorkPermitApiService.extendWorkPermit(
          this.props.scheduleId,
          this.state.closingRemarkText,
          this.state.closingActionId,
          convertDateToUTC(endDate),
        );
        await this._setDataLoading(false);
        // if (
        //   response &&
        //   (response.status === 200 ||
        //     response.status === "200" ||
        //     response.status === "success" ||
        //     response.success === true ||
        //     response.code === 200 ||
        //     response.code === "200")
        // ) {
        AlertMessage({
          message: "Work Permit Extended Successfully.",
          type: "success",
        });
        this.props.handleClose();
        this.props.refresh();
        // } else {
        //   AlertMessage({
        //     message:
        //       response.message ||
        //       "Failed to extend work permit. Please try again.",
        //     type: "error",
        //   });
        // }
      } catch (error) {
        await this._setDataLoading(false);
        AlertMessage({
          message: "Something went wrong. Please try again.",
          type: "error",
        });
      }
      return;
    }

    if (this.props.type == "decline" && this.props.isSpring) {
      if (!this.state.closingRemarkText) {
        this.setState({ closingRemarkError: true });
        return;
      }
      if (!this.state.closingActionId) {
        this.setState({ closingActionError: true });
        return;
      }

      try {
        const response = await WorkPermitApiService.declineWorkPermit(
          this.props.wpuId,
          this.state.closingActionId,
          this.state.closingRemarkText,
        );

        //if (response.status === 200) {
        AlertMessage({
          message: response.msg,
          type: "success",
        });

        this.props.handleClose();
        this.props.refresh();
        //}
      } catch (error) {
        AlertMessage({
          message: "Something went wrong.",
          type: "error",
        });
      } finally {
        this._setDataLoading(false);
      }
    }
  };

  _calculateEndDate = () => {
    let cal = moment(
      convertDateFromTimezone(this.props.extendData.endDate),
      "DD-MM-YYYY HH:mm",
    )
      .add(1, "hours")
      .valueOf();
    if (this.state.selectedEndDate > cal) {
      cal = this.state.selectedEndDate;
    } else {
      this.setState({
        selectedEndDate: cal,
      });
    }
    return cal;
  };

  _addDurationsInHours(hours = 1, durationStr = "8 hour(s)") {
    if (typeof hours !== "number" || isNaN(hours)) {
      hours = 0;
    }
    const additionalHours = this._parseDurationToHours(durationStr);
    return hours + additionalHours;
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Modal
          show={true}
          onHide={this.props.handleClose}
          className="closePopup"
          backdrop="static"
          keyboard={false}
          // style={{ width: "20vw" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>{`${this.state.dropDownTitle} ${t("remarkReason")}`}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Data Loading  */}
            <div
              className="loader"
              style={{ display: this.state.dataLoading ? "block" : "none" }}
            >
              <LoadingImage />
            </div>
            <div className="rd-content">
              <div className="rd-box">
                {this.props.type == "extend" && (
                  <>
                    <Row>
                      <Col className="pl-0">
                        <div className="form-group">
                          <label className="form-label">{t("startDate")}</label>
                          <p className="form-view-text">
                            {/* {this.props.extendData.startDate} */}
                            {`${convertDateFromTimezone(this.props.extendData.startDate)}`}
                          </p>
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label className="form-label">{t("endDate")}</label>
                          <p className="form-view-text">
                            {/* {this.props.extendData.endDate} */}
                            {`${convertDateFromTimezone(this.props.extendData.endDate)}`}
                          </p>
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label className="form-label">
                            {t("timeDuration")}
                          </label>
                          <p className="form-view-text">
                            {`${this.props.extendData.timeDuration}`}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <div className="form-group">
                      <label className="form-label">
                        {t("endDate")} & {t("time")}
                      </label>
                      <div className="calender-div">
                        <DatePicker
                          selected={this.state.selectedEndDate}
                          minDate={this.state.maxDatepickerDate}
                          showTimeSelect
                          timeFormat="HH:mm"
                          dateFormat="dd/MM/yyyy HH:mm"
                          onChange={(jsDate) =>
                            this._handleChange(jsDate, "end_date")
                          }
                        />
                        <Calendar className="calender-icon" />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        {t("extendedTimeDuration")}
                      </label>
                      <p className="form-view-text">
                        {`${this.state.extendedTimeDuration} Hr`}
                      </p>
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        {t("totalTimeDuration")}
                      </label>
                      <p className="form-view-text">
                        {`${this.state.totalDuration} Hr`}
                      </p>
                    </div>
                  </>
                )}
                <div className="form-group">
                  <div className="rd-box-head">
                    {/* <h3> */}
                    {`${this.state.dropDownTitle} ${t("remark")}`}
                    <span className="inputErrorMsg">&nbsp;*</span>
                    {/* </h3> */}
                  </div>
                  <input
                    className="form-control"
                    onChange={(event) =>
                      this._handleChange(event.target.value, "closing_remark")
                    }
                    value={this.state.closingRemarkText}
                    // placeholder={this._dynamicObservationPlaceHolder()}
                  ></input>
                  {!!this.state.closingRemarkError && (
                    <p className="inputErrorMsg">{t("requiredMessage")}</p>
                  )}
                </div>
                {/* <div className="form-group"> */}
                {/* <div className="rd-box-head">
                    <h3>
                      Closing Action
                      <span className="inputErrorMsg">&nbsp;*</span>
                    </h3>
                  </div> */}
                <CommonDropdown
                  title={`${this.state.dropDownTitle} ${t("reason")}`}
                  optionList={this.state.reasonList}
                  onChangeHandle={this._closingActionChangeHandle}
                  isRequired={false}
                  value={this.state.closingActionId}
                />
                {!!this.state.closingActionError && (
                  <p className="inputErrorMsg">{requiredMessage}</p>
                )}
                {/* </div> */}
              </div>
            </div>
            <div className="modal-footer-btn">
              <button
                type="submit"
                className="red-btn"
                onClick={this.handleWorkPermitClose}
              >
                {`${this.state.dropDownTitle} ${t("permit")}`}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

// export default withRouter(connect(mapStateToProps, null)(CloseModal));
// export default compose(
//   withRouter,
//   withTranslation(["workpermit","util"])
// )(CloseModal);

export default compose(
  withRouter,
  connect(mapStateToProps, null),
  withTranslation(["workpermit", "util"]),
)(CloseModal);
